export default __webpack_public_path__ + "static/media/user.b632d6a4.svg";